import React, { useEffect, useRef, useState } from 'react';

import PopOverContent from './components/PopoverContent';

interface CustomPopoverInterface {
  clickableElement: JSX.Element | string;
  popOverContent: JSX.Element | string;
  inBetweenSpace?: number;
}

/**
 * Pop-over component - opens a popup near a target element
 * Clickable elements parent component should have a defined width
 * @param properties
 * @returns
 */
function CustomPopover(properties: CustomPopoverInterface) {
  const { clickableElement, popOverContent, inBetweenSpace } = properties;

  const popoverReference = useRef<HTMLDivElement | null>(null);
  const buttonReference = useRef<HTMLDivElement | null>(null);
  const [openPopover, setOpenPopover] = useState<boolean>(false);

  /**
   * Function to open a popover near a clickable element
   */
  const handleOpenPopover = () => {
    if (!openPopover && buttonReference.current) {
      setOpenPopover(true);
    }
  };

  /**
   * Function to handle click events
   * @param event
   */
  const handleClickOutside = (event: MouseEvent) => {
    // Check if click was outside the popover
    if (popoverReference.current && !popoverReference.current.contains(event.target as Node)) {
      setOpenPopover(false);
    }
  };

  /**
   * Function to determine the position of the popover
   * @returns
   */
  const handlePopOverPosition = () => {
    if (!popoverReference.current || !buttonReference.current) {
      return;
    }
    const buttonRect = buttonReference.current.getBoundingClientRect();
    // const popOverRect = popoverReference.current.getBoundingClientRect();

    // To-Do -> Adjust the placement of the popover container <->
    // <-> Based on the placement of the button and the space in the screen
    const gap = inBetweenSpace || 3; // By default the inBetweenSpace will be 3px
    popoverReference.current.style.top = `${buttonRect.top + buttonRect.height + gap}px`;
    popoverReference.current.style.left = `${buttonRect.left}px`;
  };

  useEffect(() => {
    if (openPopover) {
      handlePopOverPosition();
    }
  }, [openPopover]);

  // Add event listener when component mounts, remove on unmount
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="custom-popover-wrap">
      <div
        className="pop-over-element"
        role="presentation"
        ref={buttonReference}
        onClick={handleOpenPopover}>
        {clickableElement}
      </div>
      {openPopover ? (
        <PopOverContent
          openPopover={openPopover}
          popOverContent={popOverContent}
          ref={popoverReference}
        />
      ) : null}
    </div>
  );
}

export default CustomPopover;
